
const pathname = window.location.pathname
const host = window.location.hostname
const origin = window.location.origin

const port = 8443

export function getApi() {

    return `${origin}/rest/service/v1`
}

export function getSubdomain() {

        const domains = host.split('.')
        const domainsLength = domains.length

        // Won't work for some country specific domains
        let subdomain = domainsLength > 2 ? domains[0] : 'default'

		// Check if subdomain ends with "sqa" and remove it
	    if (subdomain.endsWith('-sqa')) {
	        subdomain = subdomain.slice(0, -4);
	    }

		// Check if subdomain ends with "portal" and remove it
	    if (subdomain.endsWith('-portal')) {
	        subdomain = subdomain.slice(0, -7);
	    }
	    
        return subdomain
}

export function isSlashyServer() {
    const slashRegex = /((\/)$)/
    return slashRegex.test(pathname)
}

/**
 * 
 * The web server adds a slash after the url, but dev doesn't
 * 
 * @returns {string} path to user log in
 */
export function setPath({ path }) {
    return isSlashyServer() ? `/${path}/` : `/${path}`
}

/**
 * 
 * section of the portal we're on
 * 
 * @returns {string} reports|login|home
 * 
 */
export function getAppArea() {    

    const reportsPathRegex = /^\/reports((\/.*$)|$)/gm
    const onReports = reportsPathRegex.test(pathname)
    if (onReports === true) return 'reports'
    
    const loginPathRegex = /^\/login((\/.*$)|$)/gm
    const onLogin = loginPathRegex.test(pathname)
    if (onLogin === true) return 'login'

    return 'home'
    
}


